import { Controller } from "stimulus";
import { Popover } from 'bootstrap';

export default class extends Controller {
  static targets = [ "tooltip"]

  connect() {
    this.initPopover();
  }

  initPopover() {
    new Popover(this.tooltipTarget, {
      trigger: 'hover',
      container: 'body',
      html: true
    });
  }
}
